import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import useStyles from './BirthdaySpinningWheel.styles';
import { BIRTHDAY_CAMPAIGN } from '../../utils/constants';
const formatTimeRemaining = (timeInMs) => {
    const days = Math.floor(timeInMs / (24 * 60 * 60 * 1000));
    const hours = Math.floor((timeInMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((timeInMs % (60 * 60 * 1000)) / (60 * 1000));
    if (days > 0) {
        return `${days} day${days !== 1 ? 's' : ''} and ${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    if (hours > 0) {
        return `${hours} hour${hours !== 1 ? 's' : ''} and ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
};
export const Participation = ({ canSpin = true, timeUntilNext = 0 }) => {
    const { classes } = useStyles();
    if (!canSpin && timeUntilNext > 0) {
        return (_jsxs(Box, { className: classes.leftContent, children: [_jsx(Typography, { className: classes.subtitle, children: "It looks like you\u2019ve already entered our competition this week." }), _jsx(Typography, { className: classes.description, children: "More prizes will be available next week." })] }));
    }
    return (_jsxs(Box, { className: classes.leftContent, children: [_jsx(Typography, { variant: "h3", className: classes.title, children: BIRTHDAY_CAMPAIGN.FEELING_LUCKY }), _jsx(Typography, { variant: "h5", className: classes.subtitle, children: BIRTHDAY_CAMPAIGN.PARTICIPATION_SUBTITLE }), _jsx(Box, { component: "div", className: classes.description, children: BIRTHDAY_CAMPAIGN.PARTICIPATION_DESCRIPTION })] }));
};
export default Participation;
